import React, { useState, useEffect, useCallback } from 'react';
import './AdminPedidos.css';
import ModalPagoManual from './ModalPagoManual';


const API = 'https://centrocomunicar.com/api-comunicar/endpoints/recursos_paga.php';
const WA  = '51940686868';

/* ── Icons ── */
const IconCheck    = () => (<svg viewBox="0 0 24 24" fill="none" width="14" height="14"><polyline points="20 6 9 17 4 12" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round"/></svg>);
const IconClose    = () => (<svg viewBox="0 0 24 24" fill="none" width="18" height="18"><line x1="18" y1="6" x2="6" y2="18" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round"/><line x1="6" y1="6" x2="18" y2="18" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round"/></svg>);
const IconRefresh  = () => (<svg viewBox="0 0 24 24" fill="none" width="15" height="15"><path d="M23 4v6h-6" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/><path d="M20.49 15a9 9 0 11-2.12-9.36L23 10" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/></svg>);
const IconSearch   = () => (<svg viewBox="0 0 24 24" fill="none" width="16" height="16"><circle cx="11" cy="11" r="8" stroke="currentColor" strokeWidth="2"/><path d="M21 21l-4.35-4.35" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/></svg>);
const IconLink     = () => (<svg viewBox="0 0 24 24" fill="none" width="15" height="15"><path d="M10 13a5 5 0 007.54.54l3-3a5 5 0 00-7.07-7.07l-1.72 1.71" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/><path d="M14 11a5 5 0 00-7.54-.54l-3 3a5 5 0 007.07 7.07l1.71-1.71" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/></svg>);
const IconWhatsapp = () => (<svg viewBox="0 0 24 24" fill="none" width="15" height="15"><path d="M21 11.5a8.38 8.38 0 01-.9 3.8 8.5 8.5 0 01-7.6 4.7 8.38 8.38 0 01-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 01-.9-3.8 8.5 8.5 0 014.7-7.6 8.38 8.38 0 013.8-.9h.5a8.48 8.48 0 018 8v.5z" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/></svg>);
const IconEye      = () => (<svg viewBox="0 0 24 24" fill="none" width="15" height="15"><path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" stroke="currentColor" strokeWidth="2"/><circle cx="12" cy="12" r="3" stroke="currentColor" strokeWidth="2"/></svg>);
const IconCopy     = () => (<svg viewBox="0 0 24 24" fill="none" width="14" height="14"><rect x="9" y="9" width="13" height="13" rx="2" stroke="currentColor" strokeWidth="2"/><path d="M5 15H4a2 2 0 01-2-2V4a2 2 0 012-2h9a2 2 0 012 2v1" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/></svg>);
const IconPlus     = () => (<svg viewBox="0 0 24 24" fill="none" width="15" height="15"><line x1="12" y1="5" x2="12" y2="19" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round"/><line x1="5" y1="12" x2="19" y2="12" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round"/></svg>);
const IconTrash    = () => (<svg viewBox="0 0 24 24" fill="none" width="14" height="14"><polyline points="3 6 5 6 21 6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/><path d="M19 6l-1 14a2 2 0 01-2 2H8a2 2 0 01-2-2L5 6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/><path d="M10 11v6M14 11v6M9 6V4a1 1 0 011-1h4a1 1 0 011 1v2" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/></svg>);
const IconSpinner  = () => (<span className="apd-spinner"/>);
const IconChevL    = () => (<svg viewBox="0 0 24 24" fill="none" width="14" height="14"><path d="M15 18l-6-6 6-6" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/></svg>);
const IconChevR    = () => (<svg viewBox="0 0 24 24" fill="none" width="14" height="14"><path d="M9 18l6-6-6-6" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/></svg>);

const ESTADO_COLOR = {
  pendiente:       { bg:'#fef3c7', color:'#92400e', label:'Pendiente' },
  voucher_enviado: { bg:'#dbeafe', color:'#1d4ed8', label:'Voucher enviado' },
  validado:        { bg:'#d1fae5', color:'#065f46', label:'Validado ✓' },
  rechazado:       { bg:'#fee2e2', color:'#c53030', label:'Rechazado' },
  reembolsado:     { bg:'#ede9fe', color:'#5b21b6', label:'Reembolsado' },
};

const POR_PAGINA_OPTS = [10, 20, 50, 100];

/* ── Componente paginación reutilizable ── */
function Paginacion({ total, pagina, porPagina, setPagina, setPorPagina }) {
  const totalPaginas = Math.max(1, Math.ceil(total / porPagina));
  const paginaSegura = Math.min(pagina, totalPaginas);
  const inicio = (paginaSegura - 1) * porPagina + 1;
  const fin    = Math.min(paginaSegura * porPagina, total);

  const paginasVisibles = () => {
    const pages = [];
    const delta = 2;
    for (let i = Math.max(1, paginaSegura - delta); i <= Math.min(totalPaginas, paginaSegura + delta); i++) {
      pages.push(i);
    }
    return pages;
  };

  if (total === 0) return null;

  return (
    <div className="apd-paginacion">
      <div className="apd-pag__info">
        <span>Mostrando {inicio}–{fin} de {total}</span>
        <div className="apd-pag__porpag">
          <span>Ver:</span>
          {POR_PAGINA_OPTS.map(n => (
            <button
              key={n}
              className={`apd-pp-btn ${porPagina === n ? 'apd-pp-btn--active' : ''}`}
              onClick={() => { setPorPagina(n); setPagina(1); }}
            >{n}</button>
          ))}
        </div>
      </div>
      {totalPaginas > 1 && (
        <div className="apd-pag__controles">
          <button className="apd-pag__btn" onClick={() => setPagina(p => Math.max(1, p - 1))} disabled={paginaSegura === 1}>
            <IconChevL/>
          </button>
          {paginasVisibles()[0] > 1 && (
            <>
              <button className="apd-pag__num" onClick={() => setPagina(1)}>1</button>
              {paginasVisibles()[0] > 2 && <span className="apd-pag__dots">…</span>}
            </>
          )}
          {paginasVisibles().map(p => (
            <button
              key={p}
              className={`apd-pag__num ${p === paginaSegura ? 'apd-pag__num--active' : ''}`}
              onClick={() => setPagina(p)}
            >{p}</button>
          ))}
          {paginasVisibles().at(-1) < totalPaginas && (
            <>
              {paginasVisibles().at(-1) < totalPaginas - 1 && <span className="apd-pag__dots">…</span>}
              <button className="apd-pag__num" onClick={() => setPagina(totalPaginas)}>{totalPaginas}</button>
            </>
          )}
          <button className="apd-pag__btn" onClick={() => setPagina(p => Math.min(totalPaginas, p + 1))} disabled={paginaSegura === totalPaginas}>
            <IconChevR/>
          </button>
        </div>
      )}
    </div>
  );
}

export default function AdminPedidos() {
  const [tab,          setTab]          = useState('pedidos');
  const [pedidos,      setPedidos]      = useState([]);
  const [links,        setLinks]        = useState([]);
  const [recursosData, setRecursosData] = useState([]);
  const [cursosData,   setCursosData]   = useState([]);
  const [tipoRecurso,  setTipoRecurso]  = useState('material');
  const [loading,      setLoading]      = useState(false);
  const [busqueda,     setBusqueda]     = useState('');
  const [filtroEst,    setFiltroEst]    = useState('todos');
  const [toast,        setToast]        = useState(null);
  const [modalPed,     setModalPed]     = useState(null);
  const [modalLink,    setModalLink]    = useState(false);
  const [copied,       setCopied]       = useState(null);
  const [guardando,    setGuardando]    = useState(false);
  const [reenviadoLink, setReenviadoLink] = useState(false);
const [linkInscripcion, setLinkInscripcion] = useState(null);
  const [modalPagoManual, setModalPagoManual] = useState(false);

  /* ── Paginación pedidos ── */
  const [paginaPed,    setPaginaPed]    = useState(1);
  const [porPaginaPed, setPorPaginaPed] = useState(10);

  /* ── Paginación links ── */
  const [paginaLink,    setPaginaLink]    = useState(1);
  const [porPaginaLink, setPorPaginaLink] = useState(10);

  const [formLink, setFormLink] = useState({
    recurso_id:'', monto:'', descripcion:'', nombre_cliente:'',
    email_cliente:'', metodo_pago:'yape', max_usos:1, expira_horas:72,
    datos_pago: { numero:'', nombre_cuenta:'', banco:'' }
  });

  const showToast = (msg, tipo='ok') => { setToast({msg,tipo}); setTimeout(()=>setToast(null),3500); };

  const cambiarTipoRecurso = (tipo) => {
    setTipoRecurso(tipo);
    setFormLink(f => ({...f, recurso_id:'', monto:'', es_curso: tipo==='curso', moodle_id:''}));
  };

  const fetchPedidos = useCallback(async () => {
    setLoading(true);
    try {
      const r = await fetch(`${API}?action=admin_pedidos`);
      const j = await r.json();
      if (j.success) setPedidos(j.data || []);
    } catch(e) { showToast('Error cargando pedidos','error'); }
    finally { setLoading(false); }
  }, []);

  const fetchLinks = useCallback(async () => {
    try {
      const r = await fetch(`${API}?action=admin_links`);
      const j = await r.json();
      if (j.success) setLinks(j.data || []);
    } catch(e) {}
  }, []);

  useEffect(() => {
    fetch(`${API}?action=admin_list`)
      .then(r => r.json())
      .then(j => { if (j.success) setRecursosData(j.data || []); })
      .catch(() => {});
    fetch('https://centrocomunicar.com/api-comunicar/endpoints/cursos_admin.php?action=list')
      .then(r => r.json())
      .then(j => { if (j.success) setCursosData(j.data || []); })
      .catch(() => {});
  }, []);

  useEffect(() => { fetchPedidos(); fetchLinks(); }, [fetchPedidos, fetchLinks]);

  /* Reset página al cambiar filtros */
  useEffect(() => { setPaginaPed(1); }, [busqueda, filtroEst, porPaginaPed]);
  useEffect(() => { setPaginaLink(1); }, [porPaginaLink]);

  /* ── Filtrar pedidos ── */
  const q = busqueda.toLowerCase();
  const pedidosFiltrados = pedidos.filter(p => {
    const mQ = !q || p.nombre?.toLowerCase().includes(q) || p.email?.toLowerCase().includes(q)
      || p.codigo?.toLowerCase().includes(q) || p.recurso_titulo?.toLowerCase().includes(q);
    const mE = filtroEst === 'todos' || p.estado === filtroEst;
    return mQ && mE;
  });

  /* ── Slices de página ── */
  const paginaSegPed  = Math.min(paginaPed,  Math.max(1, Math.ceil(pedidosFiltrados.length / porPaginaPed)));
  const pedidosPagina = pedidosFiltrados.slice((paginaSegPed - 1) * porPaginaPed, paginaSegPed * porPaginaPed);

  const paginaSegLink = Math.min(paginaLink, Math.max(1, Math.ceil(links.length / porPaginaLink)));
  const linksPagina   = links.slice((paginaSegLink - 1) * porPaginaLink, paginaSegLink * porPaginaLink);

  /* ── KPIs ── */
  const pendientes     = pedidos.filter(p=>p.estado==='pendiente').length;
  const voucherEnviado = pedidos.filter(p=>p.estado==='voucher_enviado').length;
  const validados      = pedidos.filter(p=>p.estado==='validado').length;
  const ingresos       = pedidos.filter(p=>p.estado==='validado').reduce((a,p)=>a+(parseFloat(p.monto)||0),0);

  /* ── Validar pago ── */
  const validarPago = async (pedidoId) => {
    if (!window.confirm('¿Confirmar el pago y activar acceso al recurso?')) return;
    setGuardando(true);
    try {
      const r = await fetch(`${API}?action=validar_pago`, {
        method:'POST', headers:{'Content-Type':'application/json'},
        body: JSON.stringify({
          pedido_id:       pedidoId,
          validado_por:    'Admin',
          referencia_pago: modalPed?._referencia || '',
        }),
      });
      const j = await r.json();
      if (!j.success) throw new Error(j.message);
      showToast('Pago validado. Acceso activado.');
      fetchPedidos();
      setModalPed(null);
    } catch(err) { showToast(err.message,'error'); }
    finally { setGuardando(false); }
  };

  /* ── Rechazar ── */
  const rechazarPedido = async (pedidoId) => {
    const notas = window.prompt('Motivo del rechazo (opcional):');
    if (notas === null) return;
    try {
      const r = await fetch(`${API}?action=rechazar_pedido`, {
        method:'POST', headers:{'Content-Type':'application/json'},
        body: JSON.stringify({ pedido_id: pedidoId, notas }),
      });
      const j = await r.json();
      if (!j.success) throw new Error(j.message);
      showToast('Pedido rechazado','error');
      fetchPedidos(); setModalPed(null);
    } catch(err) { showToast(err.message,'error'); }
  };

  /* ── Eliminar ── */
  const eliminarPedido = async (pedidoId) => {
    if (!window.confirm('¿Eliminar este pedido permanentemente?')) return;
    try {
      const r = await fetch(`${API}?action=rechazar_pedido`, {
        method:'POST', headers:{'Content-Type':'application/json'},
        body: JSON.stringify({ pedido_id: pedidoId, notas:'Eliminado por admin' }),
      });
      const j = await r.json();
      if (!j.success) throw new Error(j.message);
      setPedidos(ps => ps.filter(p => p.id !== pedidoId));
      showToast('Pedido eliminado');
    } catch(err) { showToast(err.message,'error'); }
  };

  /* ── Generar link ── */
  const generarLink = async () => {
    if (!formLink.recurso_id || !formLink.monto) { showToast('Selecciona recurso y monto','error'); return; }
    setGuardando(true);
    try {
      const r = await fetch(`${API}?action=generar_link_pago`, {
        method:'POST', headers:{'Content-Type':'application/json'},
        body: JSON.stringify({
          ...formLink,
          monto:        parseFloat(formLink.monto),
          max_usos:     parseInt(formLink.max_usos),
          expira_horas: parseInt(formLink.expira_horas),
          datos_pago:   formLink.datos_pago,
          es_curso:     formLink.es_curso,
          moodle_id:    formLink.moodle_id || formLink.recurso_id,
        }),
      });
      const j = await r.json();
      if (!j.success) throw new Error(j.message);
      showToast('Link de pago generado');
      setModalLink(false);
      fetchLinks();
      if (j.data?.wa_url) window.open(j.data.wa_url, '_blank');
    } catch(err) { showToast(err.message,'error'); }
    finally { setGuardando(false); }
  };

  const copiarLink = (url, id) => {
    navigator.clipboard.writeText(url);
    setCopied(id);
    setTimeout(() => setCopied(null), 2000);
    showToast('Link copiado');
  };

  const enviarLinkWA = (link) => {
    const msg = `Hola ${link.nombre_cliente || ''}, aquí tienes el link de pago:\n📦 *${link.recurso_titulo}*\n💰 S/. ${parseFloat(link.monto).toFixed(2)}\n\n🔗 ${link.url_publica}\n\nVálido hasta: ${new Date(link.expira_at).toLocaleString('es-PE')}`;
    window.open(`https://wa.me/${WA}?text=${encodeURIComponent(msg)}`, '_blank');
  };



  const reenviarLinkInscripcion = async (pedidoId) => {
    setGuardando(true);
    try {
      const r = await fetch(`${API}?action=reenviar_inscripcion`, {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ pedido_id: pedidoId }),
      });
      const j = await r.json();
      if (!j.success) throw new Error(j.message);
      setLinkInscripcion(j.data.url);
      setReenviadoLink(true);
      showToast(`Link reenviado a ${j.data.email}`);
    } catch (e) { showToast(e.message, 'error'); }
    finally { setGuardando(false); }
  };




  return (
    <div className="apd-page">

      {toast && (
        <div className={`apd-toast apd-toast--${toast.tipo}`}>
          {toast.tipo==='ok'?<IconCheck/>:<IconClose/>} {toast.msg}
        </div>
      )}

      {/* KPIs */}
      <div className="apd-kpis">
        <div className="apd-kpi"><p>Pendientes</p><strong>{pendientes}</strong><span>Esperando pago</span></div>
        <div className="apd-kpi apd-kpi--azul"><p>Con voucher</p><strong>{voucherEnviado}</strong><span>Por validar</span></div>
        <div className="apd-kpi apd-kpi--verde"><p>Validados</p><strong>{validados}</strong><span>Acceso activo</span></div>
        <div className="apd-kpi"><p>Ingresos validados</p><strong>S/. {ingresos.toFixed(2)}</strong><span>Total confirmado</span></div>
      </div>

      {/* Tabs */}
      <div className="apd-tabs">
        <button className={`apd-tab ${tab==='pedidos'?'apd-tab--active':''}`} onClick={()=>setTab('pedidos')}>
          📋 Pedidos <span className="apd-tab-count">{pedidos.length}</span>
        </button>
        <button className={`apd-tab ${tab==='links'?'apd-tab--active':''}`} onClick={()=>setTab('links')}>
          🔗 Links de pago <span className="apd-tab-count">{links.length}</span>
        </button>
        <button className="apd-btn-new-link" onClick={() => setModalPagoManual(true)}>
  Registrar pago manual
</button>
        <button className="apd-btn-new-link" onClick={()=>setModalLink(true)}>
          <IconPlus/> Generar link de pago
        </button>
      </div>

      {/* ══ TAB PEDIDOS ══ */}
      {tab === 'pedidos' && (
        <>
          <div className="apd-toolbar">
            <div className="apd-search">
              <IconSearch/>
              <input type="text" placeholder="Buscar por nombre, email, código…"
                value={busqueda} onChange={e=>setBusqueda(e.target.value)}/>
              {busqueda && <button onClick={()=>setBusqueda('')}><IconClose/></button>}
            </div>
            <div className="apd-filtros-est">
              {['todos','pendiente','voucher_enviado','validado','rechazado'].map(e=>(
                <button key={e}
                  className={`apd-fil-btn ${filtroEst===e?'apd-fil-btn--active':''}`}
                  onClick={()=>setFiltroEst(e)}
                >
                  {e==='todos'?'Todos':ESTADO_COLOR[e]?.label||e}
                </button>
              ))}
            </div>
            <button className="apd-btn-ghost" onClick={fetchPedidos}><IconRefresh/></button>
            <span className="apd-count">{pedidosFiltrados.length} pedidos</span>
          </div>

          <div className="apd-tabla-wrap">
            <table className="apd-tabla">
              <thead>
                <tr><th>Código</th><th>Cliente</th><th>Recurso</th><th>Monto</th><th>Estado</th><th>Fecha</th><th></th></tr>
              </thead>
              <tbody>
                {loading ? (
                  <tr><td colSpan="7" className="apd-loading"><IconSpinner/> Cargando…</td></tr>
                ) : pedidosPagina.length === 0 ? (
                  <tr><td colSpan="7" className="apd-empty">No hay pedidos con ese criterio</td></tr>
                ) : pedidosPagina.map(p => {
                  const est = ESTADO_COLOR[p.estado] || ESTADO_COLOR.pendiente;
                  return (
                    <tr key={p.id} className="apd-tr">
                      <td><span className="apd-codigo">{p.codigo}</span></td>
                      <td>
                        <div className="apd-cliente">
                          <strong>{p.nombre}</strong>
                          <span>{p.email}</span>
                          {p.telefono && <span>{p.telefono}</span>}
                        </div>
                      </td>
                      <td><span className="apd-recurso-titulo">{p.recurso_titulo}</span></td>
                      <td><strong className="apd-monto">S/. {parseFloat(p.monto).toFixed(2)}</strong></td>
                      <td>
                        <span className="apd-estado" style={{background:est.bg,color:est.color}}>
                          {est.label}
                        </span>
                      </td>
                      <td className="apd-fecha">{new Date(p.created_at).toLocaleDateString('es-PE')}</td>
                      <td>
                        <div className="apd-acciones">
                        <button className="apd-icon-btn" onClick={()=>{ setModalPed(p); setReenviadoLink(false); setLinkInscripcion(null); }} title="Ver detalle">    <IconEye/></button>
                          {(p.estado==='pendiente'||p.estado==='voucher_enviado') && (
                            <button className="apd-icon-btn apd-icon-btn--ok" onClick={()=>validarPago(p.id)} title="Validar pago"><IconCheck/></button>
                          )}
                          <a href={`https://wa.me/${p.telefono||WA}?text=${encodeURIComponent(`Hola ${p.nombre}, tu pedido ${p.codigo} está listo.`)}`}
                            target="_blank" rel="noopener noreferrer" className="apd-icon-btn apd-icon-btn--wa" title="WhatsApp">
                            <IconWhatsapp/>
                          </a>
                          <button className="apd-icon-btn apd-icon-btn--del" onClick={()=>eliminarPedido(p.id)} title="Eliminar pedido">
                            <IconTrash/>
                          </button>
                        </div>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>

          <Paginacion
            total={pedidosFiltrados.length}
            pagina={paginaSegPed}
            porPagina={porPaginaPed}
            setPagina={setPaginaPed}
            setPorPagina={setPorPaginaPed}
          />
        </>
      )}

      {/* ══ TAB LINKS ══ */}
      {tab === 'links' && (
        <>
          <div className="apd-links-grid">
            {links.length === 0 ? (
              <div className="apd-empty-box">No hay links de pago generados aún.</div>
            ) : linksPagina.map(lk => (
              <div key={lk.id} className={`apd-link-card ${!lk.activo?'apd-link-card--inactivo':''}`}>
                <div className="apd-link-card__head">
                  <div>
                    <strong>{lk.recurso_titulo}</strong>
                    {lk.nombre_cliente && <span>Para: {lk.nombre_cliente}</span>}
                  </div>
                  <span className="apd-link-monto">S/. {parseFloat(lk.monto).toFixed(2)}</span>
                </div>
                <div className="apd-link-url">
                  <span>{lk.url_publica}</span>
                  <button onClick={()=>copiarLink(lk.url_publica, lk.id)} title="Copiar link">
                    {copied===lk.id ? '✓' : <IconCopy/>}
                  </button>
                </div>
                <div className="apd-link-meta">
                  <span>Usos: {lk.usos}/{lk.max_usos}</span>
                  <span>Expira: {lk.expira_at ? new Date(lk.expira_at).toLocaleDateString('es-PE') : 'Sin límite'}</span>
                  <span className={`apd-link-estado ${lk.activo&&lk.usos<lk.max_usos?'apd-link-estado--ok':'apd-link-estado--usado'}`}>
                    {lk.activo && lk.usos < lk.max_usos ? 'Activo' : 'Utilizado'}
                  </span>
                </div>
                <div className="apd-link-btns">
                  <button className="apd-btn-wa-link" onClick={()=>enviarLinkWA(lk)}>
                    <IconWhatsapp/> Enviar por WhatsApp
                  </button>
                  <button className="apd-btn-copy-link" onClick={()=>copiarLink(lk.url_publica, lk.id)}>
                    <IconLink/> {copied===lk.id?'¡Copiado!':'Copiar link'}
                  </button>
                </div>
              </div>
            ))}
          </div>

          {links.length > 0 && (
            <Paginacion
              total={links.length}
              pagina={paginaSegLink}
              porPagina={porPaginaLink}
              setPagina={setPaginaLink}
              setPorPagina={setPorPaginaLink}
            />
          )}
        </>
      )}

      {/* ══ MODAL VER PEDIDO ══ */}
      {modalPed && (
        <div className="apd-overlay" onClick={()=>setModalPed(null)}>
          <div className="apd-modal" onClick={e=>e.stopPropagation()}>
            <div className="apd-modal__head">
              <div>
                <h2>Pedido {modalPed.codigo}</h2>
                <p>{ESTADO_COLOR[modalPed.estado]?.label}</p>
              </div>
              <button className="apd-modal__close" onClick={()=>setModalPed(null)}><IconClose/></button>
            </div>
            <div className="apd-modal__body">
              <div className="apd-ped-grid">
                <div><span>Cliente</span><strong>{modalPed.nombre}</strong></div>
                <div><span>Email</span><strong>{modalPed.email}</strong></div>
                <div><span>Teléfono</span><strong>{modalPed.telefono||'—'}</strong></div>
                <div><span>Recurso</span><strong>{modalPed.recurso_titulo}</strong></div>
                <div><span>Monto</span><strong>S/. {parseFloat(modalPed.monto).toFixed(2)}</strong></div>

                {/* Descuento de puntos — solo si aplica */}
                {parseFloat(modalPed.descuento_puntos) > 0 && (
                  <>
                    <div>
                      <span>Descuento puntos</span>
                      <strong style={{color:'#4db88a'}}>
                        − S/. {parseFloat(modalPed.descuento_puntos).toFixed(2)}
                      </strong>
                    </div>
                    <div>
                      <span>Puntos canjeados</span>
                      <strong style={{color:'#4db88a'}}>
                        ⭐ {parseInt(modalPed.puntos_usados).toLocaleString()} pts
                      </strong>
                    </div>
                    <div>
                      <span>Monto original</span>
                      <strong style={{color:'#5a6a63', textDecoration:'line-through'}}>
                        S/. {(parseFloat(modalPed.monto) + parseFloat(modalPed.descuento_puntos)).toFixed(2)}
                      </strong>
                    </div>
                  </>
                )}

                <div><span>Método</span><strong>{modalPed.metodo_pago}</strong></div>
                <div><span>Estado</span>
                  <span className="apd-estado" style={{background:ESTADO_COLOR[modalPed.estado]?.bg,color:ESTADO_COLOR[modalPed.estado]?.color}}>
                    {ESTADO_COLOR[modalPed.estado]?.label}
                  </span>
                </div>
                <div><span>Fecha</span><strong>{new Date(modalPed.created_at).toLocaleString('es-PE')}</strong></div>
                {modalPed.validado_at && (
                  <div><span>Validado</span><strong>{new Date(modalPed.validado_at).toLocaleString('es-PE')}</strong></div>
                )}
                {modalPed.referencia_pago && (
                  <div><span>N° Operación</span><strong>{modalPed.referencia_pago}</strong></div>
                )}
                {modalPed.notas_admin && (
                  <div className="apd-ped-full"><span>Notas</span><p>{modalPed.notas_admin}</p></div>
                )}
                {modalPed.voucher_url && (
                  <div className="apd-ped-full">
                    <span>Voucher</span>
                    <a href={modalPed.voucher_url} target="_blank" rel="noopener noreferrer" className="apd-voucher-link">
                      Ver comprobante ↗
                    </a>
                  </div>
                )}



{/* Link de inscripción — solo si es curso validado */}
{modalPed.estado === 'validado' &&
 (modalPed.notas_admin?.includes('Curso Moodle') || modalPed.recurso_titulo?.toLowerCase().includes('curso') || modalPed.recurso_titulo?.toLowerCase().includes('taller')) && (
  <div className="apd-ped-full">
    <span>🎓 Link de inscripción al curso</span>
    {linkInscripcion ? (
      <div style={{ display:'flex', flexDirection:'column', gap:'.5rem', marginTop:'.4rem' }}>
        <div style={{ display:'flex', gap:'.5rem', alignItems:'center' }}>
          <input
            type="text" readOnly value={linkInscripcion}
            style={{ flex:1, padding:'.5rem .8rem', borderRadius:8, border:'1.5px solid rgba(130,216,179,.3)', fontSize:'.78rem', color:'#5a6a63', background:'#f9fffe' }}
          />
          <button
            onClick={() => { navigator.clipboard.writeText(linkInscripcion); showToast('Link copiado'); }}
            style={{ padding:'.5rem .9rem', borderRadius:8, background:'#111614', color:'#82D8B3', border:'none', fontFamily:'inherit', fontSize:'.78rem', fontWeight:700, cursor:'pointer' }}
          >
            Copiar
          </button>
        </div>
        <a href={`https://wa.me/${modalPed.telefono || WA}?text=${encodeURIComponent('Hola ' + modalPed.nombre + ', aquí está tu link de inscripción al curso:\n\n' + linkInscripcion)}`}
          target="_blank" rel="noopener noreferrer"
          style={{ display:'inline-flex', alignItems:'center', gap:'.4rem', background:'#25d366', color:'#fff', padding:'.5rem 1rem', borderRadius:8, fontSize:'.78rem', fontWeight:700, textDecoration:'none' }}
        >
          <IconWhatsapp/> Enviar por WhatsApp
        </a>
      </div>
    ) : (
      <button
        onClick={() => reenviarLinkInscripcion(modalPed.id)}
        disabled={guardando}
        style={{ marginTop:'.4rem', display:'inline-flex', alignItems:'center', gap:'.4rem', background:'#111614', color:'#82D8B3', border:'none', borderRadius:8, padding:'.6rem 1.1rem', fontFamily:'inherit', fontSize:'.82rem', fontWeight:700, cursor:'pointer' }}
      >
        {guardando ? '⏳ Enviando…' : '📧 Reenviar link de inscripción'}
      </button>
    )}
    <span style={{ fontSize:'.72rem', color:'#9ca3af', marginTop:'.2rem', display:'block' }}>
      Se enviará al correo: {modalPed.email}
    </span>
  </div>
)}



                {(modalPed.estado==='pendiente'||modalPed.estado==='voucher_enviado') && (
                  <div className="apd-ped-full">
                    <span>N° de operación / referencia de pago</span>
                    <input
                      type="text"
                      placeholder="Ej: 123456789 (opcional)"
                      className="apd-ref-input"
                      value={modalPed._referencia||''}
                      onChange={e=>setModalPed(p=>({...p,_referencia:e.target.value}))}
                    />
                  </div>
                )}
              </div>
            </div>
            <div className="apd-modal__foot">
              {(modalPed.estado==='pendiente'||modalPed.estado==='voucher_enviado') && (
                <>
                  <button className="apd-btn-rechazar" onClick={()=>rechazarPedido(modalPed.id)} disabled={guardando}>
                    Rechazar
                  </button>
                  <button className="apd-btn-validar" onClick={()=>validarPago(modalPed.id)} disabled={guardando}>
                    {guardando?<><IconSpinner/> …</>:<><IconCheck/> Validar pago</>}
                  </button>
                </>
              )}
              <button className="apd-btn-ghost" onClick={()=>setModalPed(null)}>Cerrar</button>
            </div>
          </div>
        </div>
      )}

      {/* ══ MODAL GENERAR LINK DE PAGO ══ */}
      {modalLink && (
        <div className="apd-overlay" onClick={()=>setModalLink(false)}>
          <div className="apd-modal apd-modal--link" onClick={e=>e.stopPropagation()}>
            <div className="apd-modal__head">
              <div><h2>Generar link de pago</h2><p>Se generará un link único para enviar al cliente por WhatsApp</p></div>
              <button className="apd-modal__close" onClick={()=>setModalLink(false)}><IconClose/></button>
            </div>
            <div className="apd-modal__body">
              <div className="apd-link-form">

               {/* Tipo de producto */}
                <div className="apd-lf-field apd-lf-field--full">
                  <label>Tipo de producto *</label>
                  <div style={{display:'flex',gap:'.5rem'}}>
                    <button type="button"
                      onClick={()=>cambiarTipoRecurso('material')}
                      style={{
                        flex:1, padding:'.7rem', borderRadius:10, cursor:'pointer',
                        fontFamily:'inherit', fontWeight:600, fontSize:'.85rem',
                        border: tipoRecurso==='material' ? '2px solid #4db88a' : '1.5px solid #e2e8f0',
                        background: tipoRecurso==='material' ? '#edfaf4' : '#fff',
                        color: tipoRecurso==='material' ? '#065f46' : '#5a6a63',
                      }}>
                      📄 Material / PDF
                    </button>
                    <button type="button"
                      onClick={()=>cambiarTipoRecurso('curso')}
                      style={{
                        flex:1, padding:'.7rem', borderRadius:10, cursor:'pointer',
                        fontFamily:'inherit', fontWeight:600, fontSize:'.85rem',
                        border: tipoRecurso==='curso' ? '2px solid #4db88a' : '1.5px solid #e2e8f0',
                        background: tipoRecurso==='curso' ? '#edfaf4' : '#fff',
                        color: tipoRecurso==='curso' ? '#065f46' : '#5a6a63',
                      }}>
                      🎓 Curso Moodle
                    </button>
                  </div>
                </div>

                {/* Selector según tipo */}
                {tipoRecurso === 'material' && (
                  <div className="apd-lf-field">
                    <label>Material *</label>
                   
                    <select value={formLink.recurso_id} onChange={e=>{
                      const rec = recursosData.find(r=>r.id===parseInt(e.target.value));
                      setFormLink(f=>({...f, recurso_id:e.target.value, monto:rec?.precio||f.monto, es_curso:false}));
                    }}>
                      <option value="">— Seleccionar material —</option>
                      {recursosData.filter(r=>r.activo).map(r=>(
                        <option key={r.id} value={r.id}>{r.titulo} (S/. {r.precio})</option>
                      ))}
                    </select>
                  </div>
                )}

                {tipoRecurso === 'curso' && (
                  <div className="apd-lf-field">
                    <label>Curso Moodle *</label>
                  
                    <select value={formLink.recurso_id} onChange={e=>{
                      const curso = cursosData.find(c=>c.id===parseInt(e.target.value));
                      setFormLink(f=>({
                        ...f,
                        recurso_id:    e.target.value,
                        moodle_id:     e.target.value,
                        monto:         curso?.precio || f.monto,
                        es_curso:      true,
                        recurso_titulo: curso?.fullname || '',
                      }));
                    }}>

                      <option value="">— Seleccionar curso —</option>
                     
                      {cursosData.filter(c=>c.visible_web).map(c=>(
                        <option key={c.id} value={c.id}>
                          {c.fullname} {c.precio ? `(S/. ${c.precio})` : '(sin precio)'}
                        </option>
                      ))}

                    </select>
                    {formLink.recurso_id && (
                      <p style={{fontSize:'.72rem',color:'#4db88a',marginTop:'.3rem'}}>
                        🎓 Al validar el pago se enviará email de inscripción automáticamente
                      </p>
                    )}
                  </div>
                )}

                <div className="apd-lf-row">
                  <div className="apd-lf-field">
                    <label>Monto (S/.) *</label>
                    <input type="number" step="0.01" value={formLink.monto}
                      onChange={e=>setFormLink(f=>({...f,monto:e.target.value}))} placeholder="0.00"/>
                  </div>
                  <div className="apd-lf-field">
                    <label>Método de pago</label>
                    <select value={formLink.metodo_pago} onChange={e=>setFormLink(f=>({...f,metodo_pago:e.target.value}))}>
                      <option value="yape">Yape</option>
                      <option value="plin">Plin</option>
                      <option value="transferencia">Transferencia bancaria</option>
                      <option value="niubiz">Niubiz (próximamente)</option>
                    </select>
                  </div>
                </div>

                {(formLink.metodo_pago==='yape'||formLink.metodo_pago==='plin') && (
                  <div className="apd-lf-field">
                    <label>Número de {formLink.metodo_pago}</label>
                    <input type="text" placeholder="9XX XXX XXX"
                      value={formLink.datos_pago.numero}
                      onChange={e=>setFormLink(f=>({...f,datos_pago:{...f.datos_pago,numero:e.target.value}}))}/>
                  </div>
                )}
                {formLink.metodo_pago==='transferencia' && (
                  <div className="apd-lf-row">
                    <div className="apd-lf-field">
                      <label>Banco</label>
                      <input type="text" placeholder="BCP, Interbank, BBVA…"
                        value={formLink.datos_pago.banco}
                        onChange={e=>setFormLink(f=>({...f,datos_pago:{...f.datos_pago,banco:e.target.value}}))}/>
                    </div>
                    <div className="apd-lf-field">
                      <label>Número de cuenta</label>
                      <input type="text" placeholder="Cuenta corriente o CCI"
                        value={formLink.datos_pago.nombre_cuenta}
                        onChange={e=>setFormLink(f=>({...f,datos_pago:{...f.datos_pago,nombre_cuenta:e.target.value}}))}/>
                    </div>
                  </div>
                )}

                <div className="apd-lf-row">
                  <div className="apd-lf-field">
                    <label>Nombre del cliente</label>
                    <input type="text" placeholder="Opcional"
                      value={formLink.nombre_cliente}
                      onChange={e=>setFormLink(f=>({...f,nombre_cliente:e.target.value}))}/>
                  </div>
                  <div className="apd-lf-field">
                    <label>Email del cliente</label>
                    <input type="email" placeholder="Opcional"
                      value={formLink.email_cliente}
                      onChange={e=>setFormLink(f=>({...f,email_cliente:e.target.value}))}/>
                  </div>
                </div>

                <div className="apd-lf-field apd-lf-field--full">
                  <label>Descripción / nota para el cliente</label>
                  <textarea rows="2" placeholder="Ej: Incluye los 3 módulos del curso + certificado digital"
                    value={formLink.descripcion}
                    onChange={e=>setFormLink(f=>({...f,descripcion:e.target.value}))}/>
                </div>

                <div className="apd-lf-row">
                  <div className="apd-lf-field">
                    <label>Válido por (horas)</label>
                    <select value={formLink.expira_horas} onChange={e=>setFormLink(f=>({...f,expira_horas:e.target.value}))}>
                      <option value="24">24 horas</option>
                      <option value="48">48 horas</option>
                      <option value="72">72 horas (3 días)</option>
                      <option value="168">7 días</option>
                      <option value="720">30 días</option>
                    </select>
                  </div>
                  <div className="apd-lf-field">
                    <label>Usos máximos</label>
                    <select value={formLink.max_usos} onChange={e=>setFormLink(f=>({...f,max_usos:e.target.value}))}>
                      <option value="1">1 uso</option>
                      <option value="3">3 usos</option>
                      <option value="5">5 usos</option>
                      <option value="99">Sin límite</option>
                    </select>
                  </div>
                </div>

                <div className="apd-lf-preview">
                  <p className="apd-lf-preview__label">📋 Flujo que verá el cliente</p>
                  <div className="apd-lf-preview__steps">
                    <div>1. Recibe el link por WhatsApp</div>
                    <div>2. Ve el detalle del recurso y precio</div>
                    <div>3. Realiza el pago por {formLink.metodo_pago}</div>
                    <div>4. Adjunta voucher en WhatsApp</div>
                    <div>5. Admin valida → acceso activado en /mi-cuenta</div>
                  </div>
                </div>

               {/*  <div className="apd-lf-niubiz">
                  <span>🔒</span>
                  <div>
                    <strong>Pasarela automática Niubiz</strong>
                    <p>Próximamente disponible. El cliente podrá pagar con tarjeta y el acceso se activará automáticamente.</p>
                  </div>
                  <span className="apd-lf-pronto">Próximamente</span>
                </div>*/}

              </div>
            </div>
            <div className="apd-modal__foot">
              <button className="apd-btn-ghost" onClick={()=>setModalLink(false)}>Cancelar</button>
              <button className="apd-btn-generar" onClick={generarLink} disabled={guardando}>
                {guardando?<><IconSpinner/> Generando…</>:<><IconLink/> Generar y abrir WhatsApp</>}
              </button>
            </div>
          </div>
        </div>
      )}






{modalPagoManual && (
  <ModalPagoManual
    onClose={() => setModalPagoManual(false)}
    onSuccess={fetchPedidos}
    showToast={showToast}
  />
)}





    </div>
  );
}